import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterMedia'
})
export class FilterMediaPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();
return items.filter( it => {
      return it.original_filename.toLowerCase().includes(searchText);
    });
   }

}
